KROWN.themeName = 'Split';
KROWN.themeVersion = '4.3.0';

const executeOnceOnDomContentLoaded = ()=>{

  // tab navigation

  let activeElement = document.activeElement;
  document.addEventListener('keyup', e=>{
    if ( e.keyCode == window.KEYCODES.TAB ) {
      if ( activeElement.classList.contains('focus') && e.target != activeElement ) {
        activeElement.classList.remove('focus');
      }
      if ( e.target.classList.contains('product-variant__input') ||
      	e.target.classList.contains('button') ||
      	e.target.classList.contains('product-item') ||
      	e.target.classList.contains('spr-summary-actions-newreview') ||
      	e.target.classList.contains('site-box-content-to-focus')
      ) {
        e.target.classList.add('focus');
      } 
      activeElement = document.activeElement;
    }
  });

  // newsletter has jump

  if ( window.location.pathname.includes('/challenge') ) {
    setTimeout(()=>{
      window.scroll({
        top: 0, 
        behavior: 'auto'
      });
    }, 300);
  }

  // fix image link borders

  document.querySelectorAll('.rte a img').forEach(elm=>{
    elm.parentNode.style.border = 'none';
  });

  // Filter handle
  
  if ( document.getElementById('site-filter-handle') ) {
    document.getElementById('site-filter-handle').addEventListener('click', e=>{
      e.preventDefault();
      document.getElementById('site-filters').show();
      document.getElementById('site-filter-handle').setAttribute('aria-expanded', 'true');
    });
  }

  // fix quick add to cart

  setTimeout(()=>{
    if ( document.querySelector('modal-box quick-view-product') ) {
      document.querySelector('modal-box quick-view-product').init();
    }
    if ( document.querySelector('modal-box quick-add-to-cart') ) {
      document.querySelector('modal-box quick-add-to-cart').init();
      document.querySelector('modal-box product-form').init();
    }
  }, 3050);

  // show newsletter popup confimation

  if ( document.location.search == '?customer_posted=true' && document.location.hash == '#newsletter-popup' && document.getElementById('modal-newsletter') ) {
    const newsletterPopup = document.getElementById('modal-newsletter');
    newsletterPopup.show();
    localStorage.setItem(newsletterPopup._modalKey, JSON.stringify({
      'shown': (new Date().getTime()),
      'content': newsletterPopup._modalText
    }));	
    setTimeout(()=>{
      newsletterPopup.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{newsletterPopup.hide(true)}));
    }, 100);
    clearTimeout(newsletterPopup._modalTimeout);
  }

  // custom cart listener
  
  if ( document.querySelector('cart-form') ) {
    document.querySelector('cart-form').addEventListener('cart-updated', ()=>{
      if ( document.body.classList.contains('template-cart') ) {

        if ( document.querySelector('#AjaxCartForm .subtitle') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = document.querySelector('#AjaxCartForm .subtitle').innerHTML;
        }
        if ( document.getElementById('AjaxCartSubtotal').querySelector('[data-cart-empty]') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = "";
          if ( ! document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
            document.getElementById('AjaxCartSubtotal').append(document.getElementById('section-cart').querySelector('template').content.cloneNode(true))
          } else {
            document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'block';
          }
        } else if ( document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
          document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'none';
        }

      }

      if ( document.querySelector('cart-recommendations') && parseInt(document.querySelector('[data-cart-count]').textContent ) == 0 ) {
        document.querySelector('cart-recommendations').innerHTML = '';
      }

    });
  }

  // recommended products listener

  if ( document.querySelector('#main-product-recommendations') ) {
    document.querySelector('#main-product-recommendations').addEventListener('product-recommendations-loaded', ()=>{
      eval(document.querySelector('#main-product-recommendations .js-fix-height').textContent);
    });
  }

}

if ( document.readyState !== 'loading' ) {
  executeOnceOnDomContentLoaded();
} else {
  document.addEventListener('DOMContentLoaded', executeOnceOnDomContentLoaded);
}

if ( typeof SiteFilterHandle !== 'function' ) {

	class SiteFilterHandle extends HTMLElement {
		constructor(){
			super();
			const sidebar = document.getElementById(this.getAttribute('aria-controls'));
			this.addEventListener('click', e=>{
				if ( ! this.classList.contains('disable-sidebar') ) {
					e.preventDefault();
					this.setAttribute('aria-expanded', 'true');
					sidebar.show();
				}
			})
			this.addEventListener('keyup', e=>{
				if ( e.keyCode == window.KEYCODES.RETURN ) {
					this.setAttribute('aria-expanded', 'true');
					sidebar.show();
					sidebar.querySelector('.site-close-handle').focus();
				}
			})
		}
  }

  if ( typeof customElements.get('site-filter-handle') == 'undefined' ) {
    customElements.define('site-filter-handle', SiteFilterHandle);
  }

}

/* ==========================================================================
   BLVCK PARIS — CLEAN HOMEPAGE CUSTOM JS
   Replace your current custom BLVCK section in theme.js with this block
   ========================================================================== */
(function () {
  var MOBILE_BREAKPOINT = 768;


  window.BLVCK_I18N = window.BLVCK_I18N || {
    en: {
      go_to_slide: "Go to slide",
      dropped_label: "New this week",
      dropped_title: "Just <em>Dropped</em>",
      view_all_new: "View all new arrivals",
      collabs_label: "Limited Editions",
      collabs_title: "Collaborations",
      all_collabs: "All Collabs",
      newest_collab: "Newest Collab",
      featured_collab: "Featured collab",
      available_now: "Available Now",
      shop_collection: "Shop Collection",
      maison_label: "The Maison",
      collections_title: "Explore <em>Collections</em>",
      shades_body: "From washed tones to the deepest black, the Shades of Blvck Collection reveals every shade of the Blvck Paris identity.",
      blog_label: "The Journal",
      blog_title: "Latest <em>blog posts</em>",
      all_articles: "All Articles",
      lifestyle: "Lifestyle",
      collaboration: "Collaboration",
      journal: "Journal",
      newsletter_label: "Join The Maison",
      newsletter_title: "Be first.<br><em>Always.</em>",
      newsletter_desc: "Exclusive early access to new drops, collaborations, and members-only offers. No spam. Just black.",
      newsletter_discount: "10% off your first order",
      newsletter_discount_desc: "Subscribe and receive an exclusive welcome discount",
      first_name: "First name",
      email_address: "Email address",
      subscribe_button: "Subscribe & Get 10% Off",
      newsletter_legal: "By subscribing you agree to receive marketing emails. Unsubscribe at any time.",
      submitting: "Submitting...",
      submitted: "Submitted ✓",
      try_again: "Try again"
    },
    fr: {
      go_to_slide: "Aller à la slide",
      dropped_label: "Nouveautés de la semaine",
      dropped_title: "Dernières <em>nouveautés</em>",
      view_all_new: "Voir toutes les nouveautés",
      collabs_label: "Éditions limitées",
      collabs_title: "Collaborations",
      all_collabs: "Toutes les collaborations",
      newest_collab: "Nouvelle collaboration",
      featured_collab: "Collaboration à la une",
      available_now: "Disponible maintenant",
      shop_collection: "Découvrir la collection",
      maison_label: "La Maison",
      collections_title: "Explorer les <em>collections</em>",
      shades_body: "Des tons délavés au noir le plus profond, la collection Shades of Blvck révèle toutes les nuances de l’identité de Blvck Paris.",
      blog_label: "Le Journal",
      blog_title: "Derniers <em>articles</em>",
      all_articles: "Tous les articles",
      lifestyle: "Lifestyle",
      collaboration: "Collaboration",
      journal: "Journal",
      newsletter_label: "Rejoignez La Maison",
      newsletter_title: "Soyez les premiers.<br><em>Toujours.</em>",
      newsletter_desc: "Accès anticipé exclusif aux nouveautés, collaborations et offres réservées aux membres. Aucun spam. Juste du noir.",
      newsletter_discount: "-10 % sur votre première commande",
      newsletter_discount_desc: "Inscrivez-vous et recevez une remise de bienvenue exclusive",
      first_name: "Prénom",
      email_address: "Adresse e-mail",
      subscribe_button: "S’inscrire et obtenir -10 %",
      newsletter_legal: "En vous inscrivant, vous acceptez de recevoir des e-mails marketing. Vous pouvez vous désinscrire à tout moment.",
      submitting: "Envoi...",
      submitted: "Envoyé ✓",
      try_again: "Réessayer"
    }
  };

  function blvckT(key, fallback) {
    var htmlLang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    var path = window.location.pathname || '';
    var locale = htmlLang.indexOf('fr') === 0 || path.indexOf('/fr') === 0 ? 'fr' : 'en';

    return (
      window.BLVCK_I18N &&
      window.BLVCK_I18N[locale] &&
      window.BLVCK_I18N[locale][key]
    ) || fallback || key;
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function debounce(fn, delay) {
    var timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(fn, delay);
    };
  }

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function createOnce(parent, selector, html) {
    var found = parent.querySelector(selector);
    if (found) return found;
    var wrapper = document.createElement('div');
    wrapper.innerHTML = html.trim();
    var node = wrapper.firstElementChild;
    parent.appendChild(node);
    return node;
  }

  function unwrapSlick(slider, method) {
    if (!slider) return;
    try {
      if (typeof jQuery !== 'undefined') {
        var $slider = jQuery(slider);
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick(method || 'unslick');
        }
      }
    } catch (e) {}

    qsa('.slick-cloned, .slick-arrow', slider).forEach(function (el) { el.remove(); });

    var slickList = slider.querySelector('.slick-list');
    if (slickList) {
      var slickTrack = slickList.querySelector('.slick-track');
      if (slickTrack) {
        while (slickTrack.firstChild) {
          slider.appendChild(slickTrack.firstChild);
        }
      }
      slickList.remove();
    }

    slider.classList.remove('slick-initialized', 'slick-slider');
    qsa('.slick-slide', slider).forEach(function (item) {
      item.classList.remove('slick-slide', 'slick-current', 'slick-active', 'slick-center');
      item.removeAttribute('tabindex');
      item.removeAttribute('aria-hidden');
      item.removeAttribute('data-slick-index');
      item.removeAttribute('style');
    });
  }

  function buildDots(track, dotsClass, itemSelector) {
    if (!track || !isMobile()) return;

    var items = qsa(itemSelector, track);
    if (!items.length) return;

    var existing = track.parentNode.querySelector('.' + dotsClass);
    if (existing) existing.remove();

    var dots = document.createElement('div');
    dots.className = dotsClass;

    items.forEach(function (_, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', blvckT('go_to_slide', 'Go to slide') + ' ' + (index + 1));
      if (index === 0) button.classList.add('is-active');
      button.addEventListener('click', function () {
        var target = items[index];
        if (!target) return;
        track.scrollTo({
          left: target.offsetLeft - 20,
          behavior: 'smooth'
        });
      });
      dots.appendChild(button);
    });

    track.parentNode.appendChild(dots);

    function updateDots() {
      var activeIndex = 0;
      var smallest = Infinity;
      items.forEach(function (item, index) {
        var distance = Math.abs(item.offsetLeft - track.scrollLeft - 20);
        if (distance < smallest) {
          smallest = distance;
          activeIndex = index;
        }
      });
      qsa('button', dots).forEach(function (button, index) {
        button.classList.toggle('is-active', index === activeIndex);
      });
    }

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateDots);
    }, { passive: true });

    updateDots();
  }

  function initJustDropped() {
    var wrapper = document.querySelector('.my-product-slider-wrapper');
    if (!wrapper) return;

    var oldH2 = wrapper.querySelector('h2');
    var viewAllLink = wrapper.querySelector('.view-all');
    var viewAllHref = viewAllLink ? viewAllLink.getAttribute('href') : '/collections/all';

    if (!wrapper.querySelector('.blvck-dropped-header') && oldH2) {
      var header = document.createElement('div');
      header.className = 'blvck-dropped-header';
      header.innerHTML =
        '<div>' +
          '<span class="blvck-dropped-label">' + blvckT('dropped_label', 'New this week') + '</span>' +
          '<h2 class="blvck-dropped-title">' + blvckT('dropped_title', 'Just <em>Dropped</em>') + '</h2>' +
        '</div>' +
        '<a class="blvck-dropped-viewall" href="' + viewAllHref + '">' + blvckT('view_all_new', 'View all new arrivals') + '</a>';
      oldH2.replaceWith(header);
      if (viewAllLink) viewAllLink.style.display = 'none';
    }

    qsa('.my-product-image', wrapper).forEach(function (image) {
      image.style.background = '#d9d9d9';
      var link = image.querySelector('a');
      if (link) {
        link.style.position = 'relative';
        link.style.display = 'block';
      }
      if (!image.querySelector('.blvck-cart-icon-mobile')) {
        var icon = document.createElement('div');
        icon.className = 'blvck-cart-icon-mobile';
        icon.innerHTML = '<svg width="28" height="28" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="14" width="32" height="28" rx="3" stroke="#111" stroke-width="2.5"/><path d="M17 18V13a7 7 0 0 1 14 0v5" stroke="#111" stroke-width="2.5" stroke-linecap="round"/><line x1="24" y1="24" x2="24" y2="34" stroke="#111" stroke-width="2.5" stroke-linecap="round"/><line x1="19" y1="29" x2="29" y2="29" stroke="#111" stroke-width="2.5" stroke-linecap="round"/></svg>';
        image.appendChild(icon);
      }
    });

    var slider = wrapper.querySelector('.my-product-slider');
    if (!slider || !isMobile()) return;

    unwrapSlick(slider, 'unslick');
    slider.classList.add('blvck-mobile-product-grid');

    qsa('.my-product-slider-item', slider).forEach(function (item, index) {
      if (index > 3) {
        item.remove();
        return;
      }
      item.removeAttribute('style');
      item.style.display = 'block';
    });
  }

  function initCollaborations() {
    var section = document.querySelector('#shopify-section-template--26582767632769__brand_dekstop_XkjNNp .brand-desktop')
      || document.querySelector('[id*="brand_dekstop"] .brand-desktop')
      || Array.prototype.slice.call(document.querySelectorAll('.brand-desktop')).find(function (candidate) {
        return candidate.querySelector('.my-collection-list2');
      });

    if (!section) return;

    var slider = section.querySelector('.my-collection-list2');
    if (!slider) return;

    if (!section.querySelector('.blvck-collabs-header')) {
      var header = document.createElement('div');
      header.className = 'blvck-collabs-header';
      header.innerHTML =
        '<div>' +
          '<span class="blvck-collabs-label">' + blvckT('collabs_label', 'Limited Editions') + '</span>' +
          '<h2 class="blvck-collabs-title">' + blvckT('collabs_title', 'Collaborations') + '</h2>' +
        '</div>' +
        '<a class="blvck-collabs-viewall" href="/collections/collabs">' + blvckT('all_collabs', 'All Collabs') + '</a>';
      section.insertBefore(header, section.firstChild);
    }

    unwrapSlick(slider, 'unslick');
    slider.classList.add('blvck-collabs-track');

var collabData = [
  {
    key: 'pringles',
    match: /pringles/i,
    eyebrow: blvckT('available_now', 'Available Now'),
    name: 'Pringles × Blvck',
    href: '/collections/blvck-x-pringles'
  },
  {
    key: 'uno',
    match: /uno/i,
    eyebrow: blvckT('available_now', 'Available Now'),
    name: 'UNO × Blvck',
    href: '/collections/uno-x-blvck'
  },
  {
    key: 'harry-potter',
    match: /(harry|hogwarts|slytherin)/i,
    eyebrow: blvckT('newest_collab', 'Newest Collab'),
    name: 'Harry Potter × Blvck',
    href: '/pages/harry-potter-x-blvck'
  },
  {
    key: 'ufc',
    match: /ufc/i,
    eyebrow: blvckT('featured_collab', 'Featured collab'),
    name: 'Blvck × UFC',
    href: '/pages/blvck-x-ufc'
  },
  {
    key: 'batman',
    match: /batman/i,
    eyebrow: blvckT('available_now', 'Available Now'),
    name: 'Batman × Blvck',
    href: '/pages/batman-x-blvck'
  }
];

    var originalItems = qsa('.my-collection-list-item', slider);
    if (!originalItems.length) return;

    function getDescriptor(item) {
      var text = item.textContent || '';
      var assetText = qsa('a, img', item).map(function (node) {
        return [
          node.getAttribute('href') || '',
          node.getAttribute('src') || '',
          node.getAttribute('alt') || '',
          node.getAttribute('aria-label') || ''
        ].join(' ');
      }).join(' ');
      return (text + ' ' + assetText).toLowerCase();
    }

    var remaining = originalItems.slice();
var orderedItems = [];

collabData.forEach(function (data) {
  var matchIndex = -1;

  for (var i = 0; i < remaining.length; i++) {
    if (data.match.test(getDescriptor(remaining[i]))) {
      matchIndex = i;
      break;
    }
  }

  if (matchIndex > -1) {
    orderedItems.push(remaining.splice(matchIndex, 1)[0]);
  }
});

/* Add every remaining Shopify block */
orderedItems = orderedItems.concat(remaining);

/* Reorder the blocks without deleting any */
orderedItems.forEach(function (item) {
  slider.appendChild(item);
});

    orderedItems.forEach(function (item, index) {
      var descriptor = getDescriptor(item);

var data = collabData.find(function (entry) {
  return entry.match.test(descriptor);
});

if (!data) {
  var firstLink =
    item.querySelector('.my-inner-div a') ||
    item.querySelector('a');

  var href = firstLink
    ? firstLink.getAttribute('href')
    : '#';

  var handle = (href || '')
    .split('?')[0]
    .split('/')
    .filter(Boolean)
    .pop() || 'collaboration';

  var generatedName = handle
    .split('-')
    .map(function (word) {
      return word
        ? word.charAt(0).toUpperCase() + word.slice(1)
        : '';
    })
    .join(' ')
    .replace(/\bX\b/g, '×');

  data = {
    key: handle,
    eyebrow: blvckT('available_now', 'Available Now'),
    name: generatedName,
    href: href
  };
}
      item.classList.add('blvck-collab-card');
      item.setAttribute('data-collab-key', data.key);
      item.removeAttribute('style');
      item.style.position = 'relative';
      item.style.overflow = 'hidden';
      item.style.float = 'none';
      item.style.maxWidth = 'none';
      item.style.minHeight = '0';
      item.style.margin = '0';

      var innerDiv = item.querySelector('.my-inner-div');
      if (innerDiv) {
        innerDiv.style.position = 'absolute';
        innerDiv.style.inset = '0';
        innerDiv.style.width = '100%';
        innerDiv.style.height = '100%';
        innerDiv.style.margin = '0';

        var link = innerDiv.querySelector('a');
        if (link) {
          link.href = data.href;
          link.style.display = 'block';
          link.style.width = '100%';
          link.style.height = '100%';
        }

        var image = innerDiv.querySelector('img');
        if (image) {
          image.style.width = '100%';
          image.style.height = '100%';
          image.style.objectFit = 'cover';
          image.style.objectPosition = 'center top';
          image.style.display = 'block';
        }
      }

      qsa('.brand-logo, .my-collection-title, h2, h3, p', item).forEach(function (node) {
        if (!node.closest('.blvck-collab-overlay-content')) {
          node.style.display = 'none';
        }
      });

      qsa('a', item).forEach(function (anchor) {
        if (!anchor.closest('.my-inner-div') && !anchor.classList.contains('blvck-collab-shop-btn')) {
          anchor.style.display = 'none';
        }
      });

      var overlay = item.querySelector('.blvck-collab-overlay-content');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'blvck-collab-overlay-content';
        item.appendChild(overlay);
      }

      overlay.innerHTML =
        '<span class="blvck-collab-featured-label">' + data.eyebrow + '</span>' +
        '<p class="blvck-collab-name">' + data.name + '</p>' +
        '<a class="blvck-collab-shop-btn" href="' + data.href + '">' + blvckT('shop_collection', 'Shop Collection') + '</a>';
    });

    if (isMobile()) {
      section.setAttribute('data-blvck-collabs-mobile', 'true');
      var cardWidth = Math.max(window.innerWidth - 96, 260);
      slider.style.display = 'flex';
      slider.style.gridTemplateColumns = '';
      slider.style.gap = '12px';
      slider.style.flexWrap = 'nowrap';
      slider.style.overflowX = 'auto';
      slider.style.overflowY = 'hidden';
      slider.style.scrollSnapType = 'x mandatory';
      slider.style.webkitOverflowScrolling = 'touch';
      slider.style.width = 'calc(100% + 40px)';
      slider.style.marginLeft = '-20px';
      slider.style.padding = '0 20px';

      orderedItems.forEach(function (item) {
        item.style.flex = '0 0 ' + cardWidth + 'px';
        item.style.width = cardWidth + 'px';
        item.style.scrollSnapAlign = 'start';
        item.style.aspectRatio = '3 / 4';
      });

      buildDots(slider, 'blvck-collab-dots', '.my-collection-list-item');
    } else {
  section.removeAttribute('data-blvck-collabs-mobile');

  var dots = section.querySelector('.blvck-collab-dots');
  if (dots) dots.remove();

  /* Remove the mobile/grid styling */
  slider.style.display = '';
  slider.style.gridTemplateColumns = '';
  slider.style.gap = '';
  slider.style.flexWrap = '';
  slider.style.overflowX = '';
  slider.style.overflowY = '';
  slider.style.scrollSnapType = '';
  slider.style.width = '100%';
  slider.style.marginLeft = '0';
  slider.style.padding = '0';

  orderedItems.forEach(function (item) {
    item.style.flex = '';
    item.style.width = '';
    item.style.scrollSnapAlign = '';
    item.style.aspectRatio = '4 / 5';
  });

  /* Initialize the desktop carousel */
  if (
    typeof jQuery !== 'undefined' &&
    typeof jQuery.fn.slick === 'function'
  ) {
    var $collabSlider = jQuery(slider);

    if ($collabSlider.hasClass('slick-initialized')) {
      $collabSlider.slick('unslick');
    }

    $collabSlider.slick({
      dots: false,
      infinite: orderedItems.length > 3,
      speed: 300,
      arrows: orderedItems.length > 3,
      autoplay: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      variableWidth: false
    });
  }
}

    if (!section._blvckCollabObserver) {
      var observer = new MutationObserver(function () {
        if (isMobile() && slider.querySelector('.slick-track, .slick-list')) {
          setTimeout(initCollaborations, 0);
        }
      });
      observer.observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
      section._blvckCollabObserver = observer;
    }
  }

  function initCollections() {
    var section = document.querySelector('#shopify-section-template--26582767632769__my_collection_list_rpLTHK');
    if (!section) return;

    var wrapper = section.querySelector('.my-collection-list-wrapper');
    if (!wrapper) return;

    if (!section.querySelector('.blvck-collections-header')) {
      var header = document.createElement('div');
      header.className = 'blvck-collections-header';
      header.innerHTML =
        '<div>' +
          '<span class="blvck-collections-label">' + blvckT('maison_label', 'The Maison') + '</span>' +
          '<h2 class="blvck-collections-title">' + blvckT('collections_title', 'Explore <em>Collections</em>') + '</h2>' +
        '</div>';
      wrapper.insertBefore(header, wrapper.firstChild);
    }

    qsa('.my-collection-list-item', section).forEach(function (item) {
      if (item.querySelector('.blvck-collection-title-overlay')) return;

      var nativeHeading = item.querySelector('h2');
      var titleText = nativeHeading ? nativeHeading.textContent.trim() : '';
      var overlay = document.createElement('div');
      overlay.className = 'blvck-collection-title-overlay';
      overlay.innerHTML = '<span>' + titleText + '</span>';
      item.appendChild(overlay);

      var lastLink = item.querySelector('a:last-of-type');
      if (lastLink && !lastLink.closest('.my-inner-div')) {
        lastLink.style.display = 'none';
      }
    });
  }

function initShades() {
  var section = document.querySelector('#section-template--26582767632769__image_with_text_wy7nj4');
  if (!section) return;

  var block = section.querySelector('#block-image_Phm6tw');
  if (!block) return;

  block.classList.remove(
    'box__image-text',
    'box--largest-padding',
    'horizontal-center',
    'vertical-bottom'
  );

  var content = block.querySelector('.site-box-content');
  var background = block.querySelector('.site-box-background');

    if (content && background && !block.querySelector('.blvck-shades-image')) {
      var imageWrap = document.createElement('div');
      imageWrap.className = 'blvck-shades-image';
      imageWrap.appendChild(background);
      block.innerHTML = '';
      block.appendChild(content);
      block.appendChild(imageWrap);
    }

    var textContent = section.querySelector('.content');
    if (!textContent) return;

    if (!textContent.querySelector('.blvck-shades-body')) {
      var body = document.createElement('p');
      body.className = 'blvck-shades-body';
      body.textContent = blvckT('shades_body', 'Black is not a color. It\'s a frequency — a vibration that absorbs everything and reveals only essence. Our core collection explores every dimension of darkness.');
      var title = textContent.querySelector('.title');
      if (title) {
        title.insertAdjacentElement('afterend', body);
      } else {
        textContent.appendChild(body);
      }
    }

    if (!textContent.querySelector('.blvck-shades-palette')) {
      var palette = document.createElement('div');
      palette.className = 'blvck-shades-palette';
      palette.innerHTML =
        '<span style="background:#000000"></span>' +
        '<span style="background:#1a1a1a"></span>' +
        '<span style="background:#2d2d2d"></span>' +
        '<span style="background:#444444"></span>' +
        '<span style="background:#666666"></span>' +
        '<span style="background:#888888"></span>' +
        '<span style="background:#aaaaaa"></span>';
      textContent.appendChild(palette);
    }
  }

  function initBlog() {
  var section = document.querySelector('#shopify-section-template--26582767632769__my_blog_nLf6Tf');
  if (!section) return;

  var wrapper = section.querySelector('.my-blog-main-wrapper');
  var track = section.querySelector('.my-blog-wrapper');
  if (!wrapper || !track) return;

  /* Safety: remove Slick if it was initialized before */
  unwrapSlick(track, 'unslick');
  track.removeAttribute('style');

  qsa('.my-blog-item', track).forEach(function (item) {
    item.removeAttribute('style');
  });

  if (!section.querySelector('.blvck-blog-header')) {
    var header = document.createElement('div');
    header.className = 'blvck-blog-header';
    header.innerHTML =
      '<div>' +
        '<span class="blvck-blog-label">' + blvckT('blog_label', 'The Journal') + '</span>' +
        '<h2 class="blvck-blog-title">' + blvckT('blog_title', 'Latest <em>blog posts</em>') + '</h2>' +
      '</div>' +
      '<a class="blvck-blog-viewall" href="/blogs/blvck-paris">' + blvckT('all_articles', 'All Articles') + '</a>';

    wrapper.insertBefore(header, wrapper.firstChild);
  }

  var categories = [blvckT('lifestyle', 'Lifestyle'), blvckT('collaboration', 'Collaboration'), blvckT('collaboration', 'Collaboration')];

  qsa('.my-blog-item', track).forEach(function (item, index) {
    if (!item.querySelector('.blvck-blog-category')) {
      var category = document.createElement('span');
      category.className = 'blvck-blog-category';
      category.textContent = categories[index] || blvckT('journal', 'Journal');

      var h2 = item.querySelector('h2');
      if (h2) item.insertBefore(category, h2);
    }
  });

  if (isMobile()) {
    track.classList.add('blvck-blog-track');

    var dots = section.querySelector('.blvck-blog-dots');
    if (dots) dots.remove();

    buildDots(track, 'blvck-blog-dots', '.my-blog-item');
  } else {
    track.classList.remove('blvck-blog-track');

    var desktopDots = section.querySelector('.blvck-blog-dots');
    if (desktopDots) desktopDots.remove();

    track.style.display = 'grid';
    track.style.gridTemplateColumns = 'repeat(3, minmax(0, 1fr))';
    track.style.gap = '32px';
  }
}

  function initNewsletter() {
    var blogSection = document.querySelector('#shopify-section-template--26582767632769__my_blog_nLf6Tf');
    if (!blogSection || document.querySelector('.blvck-newsletter-section')) return;

    var newsletterSection = document.createElement('div');
    newsletterSection.className = 'blvck-newsletter-section';
    newsletterSection.innerHTML =
      '<div class="blvck-newsletter-left">' +
        '<span class="blvck-newsletter-label">' + blvckT('newsletter_label', 'Join The Maison') + '</span>' +
        '<h2 class="blvck-newsletter-title">' + blvckT('newsletter_title', 'Be first.<br><em>Always.</em>') + '</h2>' +
        '<p class="blvck-newsletter-desc">' + blvckT('newsletter_desc', 'Exclusive early access to new drops, collaborations, and members-only offers. No spam. Just black.') + '</p>' +
      '</div>' +
      '<div class="blvck-newsletter-right">' +
        '<div class="blvck-newsletter-badge">' +
          '<span class="blvck-newsletter-badge-icon">%</span>' +
          '<div><strong>' + blvckT('newsletter_discount', '10% off your first order') + '</strong><span>' + blvckT('newsletter_discount_desc', 'Subscribe and receive an exclusive welcome discount') + '</span></div>' +
        '</div>' +
        '<iframe name="blvck-newsletter-frame" id="blvck-newsletter-frame" style="display:none;"></iframe>' +
'<form method="post" action="/contact#blvck-klaviyo-form" target="blvck-newsletter-frame" accept-charset="UTF-8" class="blvck-newsletter-form" id="blvck-klaviyo-form">' +
  '<input type="hidden" name="form_type" value="customer" />' +
  '<input type="hidden" name="utf8" value="✓" />' +
  '<input type="hidden" name="contact[tags]" value="newsletter" />' +
  '<input type="text" name="contact[first_name]" placeholder="' + blvckT('first_name', 'First name') + '" class="blvck-newsletter-input" />' +
  '<input type="email" name="contact[email]" placeholder="' + blvckT('email_address', 'Email address') + '" class="blvck-newsletter-input" required />' +
  '<button type="submit" class="blvck-newsletter-btn">' + blvckT('subscribe_button', 'Subscribe & Get 10% Off') + '</button>' +
  '<p class="blvck-newsletter-legal">' + blvckT('newsletter_legal', 'By subscribing you agree to receive marketing emails. Unsubscribe at any time.') + '</p>' +
'</form>' +
      '</div>';
    blogSection.after(newsletterSection);
  }

function initNewsletterSubmit() {
  if (document.body.dataset.blvckNewsletterBound === 'true') return;
  document.body.dataset.blvckNewsletterBound = 'true';

  document.addEventListener('submit', function (event) {
    if (!event.target.matches('#blvck-klaviyo-form')) return;

    event.preventDefault();

    var form = event.target;
    var button = form.querySelector('.blvck-newsletter-btn');
    var firstNameInput = form.querySelector('input[name="contact[first_name]"], input[type="text"]');
    var emailInput = form.querySelector('input[name="contact[email]"], input[type="email"]');

    if (!emailInput || !emailInput.value.trim() || !button) return;

    var originalText = button.textContent;
    var email = emailInput.value.trim();
    var firstName = firstNameInput ? firstNameInput.value.trim() : '';

    button.textContent = blvckT('submitting', 'Submitting...');
    button.disabled = true;
    button.style.opacity = '0.7';

    fetch('https://a.klaviyo.com/client/subscriptions?company_id=N3rtWx', {
      method: 'POST',
      headers: {
        'content-type': 'application/vnd.api+json',
        'revision': '2026-04-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'BLVCK Homepage Newsletter',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  first_name: firstName,
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED'
                      }
                    }
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: 'NVqhE5'
              }
            }
          }
        }
      })
    })
    .then(function (response) {
      if (response.status === 202 || response.ok) {
        button.textContent = blvckT('submitted', 'Submitted ✓');
        button.disabled = true;
        button.style.opacity = '1';

        form.querySelectorAll('.blvck-newsletter-input').forEach(function (input) {
          input.value = '';
        });
      } else {
        return response.text().then(function (text) {
          console.log('Klaviyo error:', text);
          throw new Error('Klaviyo submit failed');
        });
      }
    })
    .catch(function (error) {
      console.log(error);
      button.textContent = blvckT('try_again', 'Try again');
      button.disabled = false;
      button.style.opacity = '1';

      setTimeout(function () {
        button.textContent = originalText;
      }, 2500);
    });
  });
}

  function initMobileNavFix() {
    if (document.body.dataset.blvckNavBound === 'true') return;
    document.body.dataset.blvckNavBound = 'true';

    document.addEventListener('click', function (event) {
      var burger = event.target.closest('.site-burger-handle, .hamburger-menu');
      if (!burger) return;

      setTimeout(function () {
        var nav = document.querySelector('#site-nav--mobile');
        if (nav) {
          nav.style.overflowY = 'scroll';
          nav.style.height = '100vh';
        }
      }, 250);
    });
  }

  function initAll() {
  initJustDropped();
  initCollaborations();
  initCollections();
  initShades();
  initBlog();
  initNewsletter();
  initNewsletterSubmit();
  initMobileNavFix();
}

  onReady(function () {
    initAll();
    [300, 900, 1800].forEach(function (delay) {
      setTimeout(initAll, delay);
    });
  });

  window.addEventListener('resize', debounce(initAll, 220));
})();